<template>
    <div>
        <template v-if="pageView == true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left">Edit Administrators</h1>
            </div>
            <div class="global-main">
                <div class="people-management-inner-content">
                    <form @submit.prevent="editAdministrator()">
                        <div class="tab-content-inner">
                                <div class="user-permissions">
                                    <div class="form-group">
                                    <label> Company </label>
                                    <select v-model="form.company_id" name="company_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('company_id') }" v-if="companies != null">
                                        <option value="" selected>Select Company</option>
                                        <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                            {{ company.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="company_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Name </label>
                                    <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Mobile No. </label>
                                    <input v-model="form.mobile_no" type="number" name="mobile_no" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile_no') }">
                                    <has-error :form="form" field="mobile_no"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> CNIC </label>
                                    <input v-model="form.cnic" type="number" name="cnic" class="form-control" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> E-Mail Address </label>
                                    <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                                    <has-error :form="form" field="email"></has-error>
                                </div>
                                <div class="form-group btn-holder">
                                    <div class="label-holder"> </div>
                                    <button class="btn btn-default" type="button" v-on:click="generatePassword" style="padding:0 20px;">Generate new password</button>
                                </div>
                                <div class="form-group">
                                    <label> Password </label>
                                    <input v-model="form.password" type="text" name="password" class="form-control" :class="{ 'is-invalid': form.errors.has('password') }">
                                    <has-error :form="form" field="password"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Confirm Password </label>
                                    <input v-model="form.password_confirmation" type="text" name="password_confirmation" class="form-control" :class="{ 'is-invalid': form.errors.has('password_confirmation') }">
                                    <has-error :form="form" field="password_confirmation"></has-error>
                                </div>
                                <div class="form-group">
                                    <label> Join Date </label>
                                    <datepicker name="join_date" v-model="form.join_date" input-class="form-control" :class="{ 'is-invalid': form.errors.has('join_date') }"></datepicker>
                                    <has-error :form="form" field="join_date"></has-error>
                                </div>
                                <label class="label block-label"> <span class="highlight-color"> Role </span> </label>
                                <div class="form-group">
                                    <select v-on:change="getPermission($event)" v-model="form.role_id" name="role_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('role_id') }" v-if="roles != null">
                                        <option value="" selected>Select Role</option>
                                        <option v-for="role in roles" v-bind:value="role.id" v-bind:key="role.id">
                                            {{ role.name }}
                                        </option>
                                    </select>
                                    <has-error :form="form" field="role_id"></has-error>
                                </div>
                                <div class="form-group">
                                    <template v-if="permissions != null">
                                        <div class="permissions-box">
                                            <div class="form-group" v-for="(permission, index) in permissions" v-bind:key="permission.id">
                                                <label class="label block-label"> <span class="highlight-color">{{index}}</span> </label>
                                                <div class="permissions-box">
                                                    <div class="row">
                                                        <div class="col-md-4 mb-2" v-for="child in permission" v-bind:key="child.id">
                                                            <label class="check-holder ml-0">
                                                                <span class="check-text"> {{child.display_name}} </span> <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="child.description"></i>
                                                                <input type="checkbox" v-bind:value="child.id" v-bind:id="'permission_'+child.id" v-model="form.rolePermissions" />
                                                                <span class="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="page-top mb-1 mb-3 clearfix">
                                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                                    <router-link to="/administrators" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                                </div>
                            </div>

                        </div>

                    </form>
                </div>
            </div>
        </template>
        <template v-else-if="pageView === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="pageView === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    company_id : '',
                    mobile_no : '',
                    cnic : '',
                    name : '',
                    email : '',
                    password : '',
                    password_confirmation : '',
                    join_date : new Date(),
                    role_id : '',
                    rolePermissions : [],
                    userPermissions : []
                }),
                role : {},
                permissions : null,
                category : null,
                companies: null,
                roles: null,
                pageView: null
            }
        },
        methods: {
            editAdministrator() {
                this.$Progress.start();
                this.form.put('/api/updateAdministrator')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Administrator updated successfully'
                        });
                        this.$router.push('/administrators');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
            getPermission(event) {
                this.$Progress.start();
                axios.get('/api/getRolePermissionData/'+event.target.value)
                .then(res => {
                    if(res.status == 200){
                        this.form.rolePermissions = [];
                        $.each(res.data.permissions, (key, value) => {
                            this.form.rolePermissions.push(value.id);
                            this.form.userPermissions = this.form.rolePermissions;
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load permissions'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load permissions'
                    });
                });
            },
            generatePassword() {
                var length = 16,
                        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&()_+",
                        retVal = "";
                for (var i = 0, n = charset.length; i < length; ++i) {
                    retVal += charset.charAt(Math.floor(Math.random() * n));
                }
                this.form.password = retVal;
                this.form.password_confirmation = retVal;
                return false;
            }
        },
        updated(){
        },
        mounted() {
            this.$Progress.start();
            axios.get('/api/editAdministrator/'+this.$route.params.id)
            .then(res => {
                if(res.status == 200){
                    this.form.id = res.data.user.id;
                    this.form.company_id = res.data.user.company_id;
                    this.form.email = res.data.user.email;
                    this.form.mobile_no = res.data.user.mobile_no;
                    this.form.cnic = res.data.user.cnic;
                    this.form.name = res.data.user.name;
                    this.form.join_date = res.data.user.joining_date;
                    this.form.role_id = res.data.userRole.id;
                    this.companies = res.data.companies;
                    this.roles = res.data.roles;
                    this.permissions = res.data.permissions;
                    this.pageView = res.data.pageView;
                    $.each(res.data.userPermissions, (key, value) => {
                        this.form.rolePermissions.push(value.id);
                    });
                    this.$Progress.finish();
                }else{
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load form data'
                    });
                }
            }).then(res => {
                $(this.$el).find('.selectpicker').selectpicker('refresh');
            })
            .catch(err => {
                this.$Progress.fail();
                swal.fire({
                    type: 'error',
                    title: 'Error to load form data'
                });
            });
        }
    }
</script>
